var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('validation-observer',{ref:"observer"},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e(),_c('form',{staticClass:"text-start",attrs:{"id":_vm.id},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('on-submit')}}},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }